import { render, staticRenderFns } from "./OrderPdf.vue?vue&type=template&id=9edf5142&scoped=true&"
import script from "./OrderPdf.vue?vue&type=script&lang=js&"
export * from "./OrderPdf.vue?vue&type=script&lang=js&"
import style0 from "./OrderPdf.vue?vue&type=style&index=0&id=9edf5142&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9edf5142",
  null
  
)

export default component.exports